<template>
  <v-card class="stat-vert-card" elevation="0">
    <div class="stat-vert-top" :style="{ background: resolvedBg }"></div>
    <v-card-text class="pa-5">
      <div class="stat-vert-row">
        <div class="stat-vert-icon" :style="{ background: resolvedBg }">
          <v-icon color="white" size="22">{{ icon }}</v-icon>
        </div>
        <div class="stat-vert-info">
          <p class="stat-vert-title">{{ statTitle }}</p>
          <div class="stat-vert-bottom">
            <span class="stat-vert-amount">{{ statistics }}</span>
            <span
              v-if="change"
              class="stat-vert-change"
              :class="checkChange(change) ? 'change-up' : 'change-down'"
            >{{ change }}</span>
          </div>
          <p v-if="subtitle" class="stat-vert-sub">{{ subtitle }}</p>
        </div>
      </div>
    </v-card-text>
  </v-card>
</template>

<script>
export default {
  props: {
    statTitle: { type: String, default: '' },
    icon: { type: String, default: '' },
    color: { type: String, default: '' },
    subtitle: { type: String, default: '' },
    statistics: { type: [String, Number], default: '' },
    change: { type: String, default: '' },
  },
  computed: {
    resolvedBg() {
      const map = {
        success: 'linear-gradient(135deg,#388E3C,#66BB6A)',
        info: 'linear-gradient(135deg,#1976D2,#42A5F5)',
        warning: 'linear-gradient(135deg,#e65100,#ff8f00)',
        error: 'linear-gradient(135deg,#D32F2F,#EF5350)',
        primary: 'linear-gradient(135deg,#e65100,#ff8f00)',
        purple: 'linear-gradient(135deg,#7B1FA2,#AB47BC)',
        teal: 'linear-gradient(135deg,#00838F,#26C6DA)',
      };
      return map[this.color] || map['primary'];
    },
  },
  setup() {
    const checkChange = (value) => {
      return value.charAt(0) === '+';
    };
    return { checkChange };
  },
};
</script>

<style scoped>
.stat-vert-card {
  border-radius: 14px !important;
  border: 1px solid rgba(0,0,0,0.06) !important;
  overflow: hidden;
}
.stat-vert-top {
  height: 5px;
}
.stat-vert-row {
  display: flex;
  align-items: flex-start;
  gap: 14px;
}
.stat-vert-icon {
  width: 48px;
  height: 48px;
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  box-shadow: 0 4px 12px rgba(0,0,0,0.18);
}
.stat-vert-info {
  flex: 1;
  min-width: 0;
}
.stat-vert-title {
  font-size: 12px;
  font-weight: 600;
  color: #94a3b8;
  text-transform: uppercase;
  letter-spacing: 0.4px;
  margin-bottom: 4px;
}
.stat-vert-bottom {
  display: flex;
  align-items: baseline;
  gap: 6px;
}
.stat-vert-amount {
  font-size: 24px;
  font-weight: 800;
  color: #1a2744;
  line-height: 1;
}
.stat-vert-change {
  font-size: 12px;
  font-weight: 600;
}
.change-up { color: #388E3C; }
.change-down { color: #D32F2F; }
.stat-vert-sub {
  font-size: 11px;
  color: #94a3b8;
  margin-top: 2px;
  margin-bottom: 0;
}
</style>
